@use 'style/utils';

*, ::slotted(p) {
    @include utils.getFontProperties(primary-400);
    margin: 0;
    padding: 0;
}

::slotted(joy-link) {
    padding: 0;
    @include utils.getFontProperties(primary-450);
}

::slotted(strong) {
    font-weight: var(--joy-font-weight-bold);
}

::slotted(small) {
    font-size: var(--joy-font-size-primary-300);
}

:host {
    display: block;
}